export enum ScreeningsGroupingLayout {
  STANDARD = 'standard',
  EXTENDED = 'extended',
  HIDDEN = 'hidden',
}
